import React from 'react'
import { connect } from 'react-redux'
import { setCurrentButton } from '../actions'
import PropTypes from 'prop-types';
import {tooltips} from '../constants'

const Button = ({buttonID, dispatch, tooltip}) => {

    function selectButton(dispatch){
        dispatch(setCurrentButton(String(buttonID)))
    }

    return(
    <button onClick={() => selectButton(dispatch)} data-tip={tooltips.ButtonSelector} ></button>
    );
};


Button.propTypes = {
    buttonID: PropTypes.number.isRequired
}

export default connect()(Button)